import { Controller } from "@hotwired/stimulus";

// Drives the MFA resend-code countdown timer.
// While the timer is running, the resend button is hidden and a countdown
// label is shown. Once the countdown reaches zero the label is hidden and
// the resend button is revealed so the user can request a new code.
export default class extends Controller {
  // button        – the resend-code button (hidden during countdown)
  // countdownText – the paragraph that displays the countdown label (updated each second)
  static targets = ["button", "countdownText"];

  // seconds           – total countdown duration; defaults to 60
  // countdownTemplate – translated HTML template with __SECONDS__ as a placeholder for the remaining time
  static values = {
    seconds: { type: Number, default: 60 },
    countdownTemplate: { type: String, default: "" },
  };

  connect() {
    // Initialise remaining time and show the countdown on load
    this.remainingTime = this.secondsValue;
    this.updateLabel();

    // Update once per second until the countdown expires
    this.timer = setInterval(() => this.progressCountdown(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  progressCountdown() {
    // Decrement the remainingTime time by 1s
    this.remainingTime -= 1;

    if (this.remainingTime <= 0) {
      // Countdown complete: stop the timer, hide the label, show the button
      clearInterval(this.timer);
      this.countdownTextTarget.hidden = true;
      this.buttonTarget.hidden = false;
    } else {
      // Still counting down – refresh the displayed seconds
      this.updateLabel();
    }
  }

  updateLabel() {
    // Replaces the __SECONDS__ placeholder in the translated template with the current remaining time.
    this.countdownTextTarget.innerHTML = this.countdownTemplateValue.replace("__SECONDS__", this.remainingTime);
  }
}
